import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SchoolEventForm } from '../Forms/SchoolEventForm';

/** Beim Bearbeiten eines Serientermins: nur dieser Termin oder alle zukünftigen der Serie */
export type SchoolEventEditScope = 'single' | 'series';

type SchoolEventModalProps = {
  selectedEventUuid: string | null;
  editScope?: SchoolEventEditScope;
  recurrenceUuid?: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const SchoolEventModal = ({
  selectedEventUuid,
  editScope = 'single',
  recurrenceUuid = null,
  isOpen,
  onClose,
}: SchoolEventModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  const title = !selectedEventUuid
    ? t('schoolEvents.add')
    : editScope === 'series'
      ? t('schoolEvents.editSeries')
      : t('schoolEvents.edit');

  return (
    <Modal title={title} isOpen={isOpen} onRequestClose={onClose} loading={loading}>
      <SchoolEventForm
        onLoading={setLoading}
        onClose={onClose}
        eventUuid={selectedEventUuid}
        editScope={editScope}
        recurrenceUuid={recurrenceUuid}
      />
    </Modal>
  );
};
